module.exports = __webpack_public_path__ + "static/media/cheerful-close-up-coffee.fc77081a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/header/assets/cheerful-close-up-coffee.jpg
// module id = 1071
// module chunks = 0